module.exports = __webpack_public_path__ + "static/home-image-1d-f8464ab20adacdf98d6316ee71182003.jpg";